import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { LocalStorange } from '../../../shared/environment';
import { TestAttributeValueDTO, TestAttributeValueFilterDTO, TestComponentDTO, TestComponentFilterDTO, TestPackageDTO, TestPackageFilterDTO, TestScenarioDTO, TestScenarioFilterDTO, UserDTO, WorkspaceDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { TestDataIntegrationDTO } from '../../../shared/interfaces/testingSphere/TestDataIntegrationDTO';
import { WorkspaceFilterDTO } from '../../../shared/interfaces/testingSphere/WorkspaceFilterDTO';
import { ErrorOutlineTwoTone } from '@mui/icons-material';

interface ItestDataIntegrationMaintenanceProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const TestDataIntegrationMaintenance: React.FC<ItestDataIntegrationMaintenanceProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [workspaceList, setWorkspaceList] = useState<WorkspaceDTO[]>([]);
    const [sourceTestPackageList, setSourceTestPackageList] = useState<TestPackageDTO[]>([]);
    const [sourceTestScenarioList, setSourceTestScenarioList] = useState<TestScenarioDTO[]>([]);
    const [sourceTestComponentList, setSourceTestComponentList] = useState<TestComponentDTO[]>([]);
    const [sourceTestAttributeValueList, setSourceTestAttributeValueList] = useState<TestAttributeValueDTO[]>([]);
    const [targetTestPackageList, setTargetTestPackageList] = useState<TestPackageDTO[]>([]);
    const [targetTestScenarioList, setTargetTestScenarioList] = useState<TestScenarioDTO[]>([]);
    const [targetTestComponentList, setTargetTestComponentList] = useState<TestComponentDTO[]>([]);
    const [targetTestAttributeValueList, setTargetTestAttributeValueList] = useState<TestAttributeValueDTO[]>([]);

    const [userList, setUserList] = useState<UserDTO[]>([]);

    const [testDataIntegrationDTO, setTestDataIntegrationDTO] = useState<TestDataIntegrationDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setTestDataIntegrationDTO({
            ...testDataIntegrationDTO,
            id: '',
            sourceTestPackageId: '',
            sourceTestScenarioId: '',
            sourceTestComponentId: '',
            sourceTestAttributeValueId: '',
            targetTestPackageId: '',
            targetTestScenarioId: '',
            targetTestComponentId:'',
            targetTestAttributeValueId: ''
        } as TestDataIntegrationDTO);

        if(isOpenMaintenance){
            handleWorkspaceGetAllAsync();
            handleUserGetAll();
            handleGetByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        if(testDataIntegrationDTO?.workspaceId === '')
            return;

        if(isOpenMaintenance)
            handleSourceTestPackageGetAllAsync();
    }, [testDataIntegrationDTO?.workspaceId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleSourceTestScenarioGetAllAsync();
    }, [testDataIntegrationDTO?.sourceTestPackageId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleSourceTestComponentGetAllAsync();
    }, [testDataIntegrationDTO?.sourceTestScenarioId]);


    useEffect(() => {
        if(isOpenMaintenance)
            handleSourceTestAttributeValueGetAllAsync();
    }, [testDataIntegrationDTO?.sourceTestComponentId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleTargetTestPackageGetAllAsync();
    }, [testDataIntegrationDTO?.workspaceId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleTargetTestScenarioGetAllAsync();
    }, [testDataIntegrationDTO?.targetTestPackageId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleTargetTestComponentGetAllAsync();
    }, [testDataIntegrationDTO?.targetTestScenarioId]);

    useEffect(() => {
        if(isOpenMaintenance)
            handleTargetTestAttributeValueGetAllAsync();
    }, [testDataIntegrationDTO?.targetTestComponentId]);

    const handleWorkspaceGetAllAsync = useCallback(async () => {
        const workspaceFilterDTO: WorkspaceFilterDTO = {
            name: '',
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('testingsphere.workspace', workspaceFilterDTO, setLoading, setWorkspaceList, showMessage);
    }, []);

    const handleSourceTestPackageGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.workspaceId === '') {
            return;
        }
        const testPackageFilterDTO: TestPackageFilterDTO = {
            name: '',
            workspaceId: testDataIntegrationDTO?.workspaceId,
        };
        GenericService.GetAllAsync1('testingsphere.testpackage', testPackageFilterDTO, setLoading, setSourceTestPackageList, showMessage);
    }, [testDataIntegrationDTO?.workspaceId]);

    const handleTargetTestPackageGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.workspaceId === '') {
            return;
        }
        const testPackageFilterDTO: TestPackageFilterDTO = {
            name: '',
            workspaceId: testDataIntegrationDTO?.workspaceId,
        };
        GenericService.GetAllAsync1('testingsphere.testpackage', testPackageFilterDTO, setLoading, setTargetTestPackageList, showMessage);
    }, [testDataIntegrationDTO?.workspaceId]);

    const handleSourceTestScenarioGetAllAsync = useCallback(async () => {

        if (testDataIntegrationDTO?.sourceTestPackageId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                sourceTestScenarioId: '',
                sourceTestComponentId: '',
                sourceTestAttributeValueId: ''
            });
            return;
        }
        const testScenarioFilterDTO: TestScenarioFilterDTO = {
            name: '',
            testPackageId: testDataIntegrationDTO?.sourceTestPackageId ?? '',
        };
        GenericService.GetAllAsync1('testingsphere.testscenario', testScenarioFilterDTO, setLoading, setSourceTestScenarioList, showMessage);
    }, [testDataIntegrationDTO?.sourceTestPackageId]);

    const handleTargetTestScenarioGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.targetTestPackageId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                targetTestScenarioId: '',
                targetTestComponentId: '',
                targetTestAttributeValueId: ''
            });
            return;
        }
        const testScenarioFilterDTO: TestScenarioFilterDTO = {
            name: '',
            testPackageId: testDataIntegrationDTO?.targetTestPackageId ?? '',
        };
        GenericService.GetAllAsync1('testingsphere.testscenario', testScenarioFilterDTO, setLoading, setTargetTestScenarioList, showMessage);
    }, [testDataIntegrationDTO?.targetTestPackageId]);

    const handleSourceTestComponentGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.sourceTestScenarioId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                sourceTestComponentId: '',
                sourceTestAttributeValueId: ''
            });
            return;
        }
        const testComponentFilterDTO: TestComponentFilterDTO = {
            testScenarioId: testDataIntegrationDTO?.sourceTestScenarioId,
        };

        GenericService.GetAllAsync1('testingsphere.testcomponent', testComponentFilterDTO, setLoading, setSourceTestComponentList, showMessage);
    }, [testDataIntegrationDTO?.sourceTestScenarioId]);

    const handleTargetTestComponentGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.targetTestScenarioId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                targetTestComponentId: '',
                targetTestAttributeValueId: ''
            });
            return;
        }

        const testComponentFilterDTO: TestComponentFilterDTO = {
            testScenarioId: testDataIntegrationDTO?.targetTestScenarioId,
        };

        GenericService.GetAllAsync1('testingsphere.testcomponent', testComponentFilterDTO, setLoading, setTargetTestComponentList, showMessage);
    }, [testDataIntegrationDTO?.targetTestScenarioId]);

    const handleSourceTestAttributeValueGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.sourceTestComponentId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                sourceTestAttributeValueId: ''
            });
            return;
        }
        const testAttributeValueFilterDTO: TestAttributeValueFilterDTO = {
            testComponentId: testDataIntegrationDTO?.sourceTestComponentId ?? '',
        };

        GenericService.GetAllViewAsync1('testingsphere.testAttributeValue', testAttributeValueFilterDTO, setActionExecuted, setLoading, setSourceTestAttributeValueList, showMessage);
    }, [testDataIntegrationDTO?.sourceTestComponentId]);

    const handleTargetTestAttributeValueGetAllAsync = useCallback(async () => {
        if (testDataIntegrationDTO?.targetTestComponentId === '') {
            setTestDataIntegrationDTO({
                ...testDataIntegrationDTO,
                targetTestAttributeValueId: ''
            });
            return;
        }
        const testAttributeValueFilterDTO: TestAttributeValueFilterDTO = {
            testComponentId: testDataIntegrationDTO?.targetTestComponentId ?? '',
        };

        GenericService.GetAllViewAsync1('testingsphere.testAttributeValue', testAttributeValueFilterDTO, setActionExecuted, setLoading, setTargetTestAttributeValueList, showMessage);
    }, [testDataIntegrationDTO?.targetTestComponentId]);

    const handleUserGetAll = useCallback(async () => {
        const filterUser = {
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('authsphere.user', filterUser, setLoading, setUserList, showMessage);
    }, []);

    const handleGetByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('testingsphere.testDataIntegration', data.id, setLoading, setTestDataIntegrationDTO, showMessage);

    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = testDataIntegrationDTO as TestDataIntegrationDTO;

        if (testDataIntegrationDTO?.id === '' || testDataIntegrationDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('testingsphere.testDataIntegration', dto, setTestDataIntegrationDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('testingsphere.testDataIntegration', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [testDataIntegrationDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='TEST DATA INTEGRATION DETAILS'
                icon='low_priority_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <SelectField
                                id='workspaceId'
                                label='Workspace'
                                value={testDataIntegrationDTO?.workspaceId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={workspaceList}
                                autoFocus={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='sourceTestPackageId'
                                label='Source Test Package'
                                value={testDataIntegrationDTO?.sourceTestPackageId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={sourceTestPackageList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='targetTestPackageId'
                                label='Target Test Package'
                                value={testDataIntegrationDTO?.targetTestPackageId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={targetTestPackageList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='sourceTestScenarioId'
                                label='Source Test Scenario'
                                value={testDataIntegrationDTO?.sourceTestScenarioId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={sourceTestScenarioList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='targetTestScenarioId'
                                label='Target Test Scenario'
                                value={testDataIntegrationDTO?.targetTestScenarioId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={targetTestScenarioList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='sourceTestComponentId'
                                label='Source Test Component'
                                value={testDataIntegrationDTO?.sourceTestComponentId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={sourceTestComponentList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='targetTestComponentId'
                                label='Target Test Component'
                                value={testDataIntegrationDTO?.targetTestComponentId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={targetTestComponentList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='sourceTestAttributeValueId'
                                label='Source Test Attribute Value'
                                value={testDataIntegrationDTO?.sourceTestAttributeValueId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={sourceTestAttributeValueList}
                                hasNoneSelect={true}
                                valueKey='id'
                                labelKey='attribute'
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='targetTestAttributeValueId'
                                label='Target Test Attribute Value'
                                value={testDataIntegrationDTO?.targetTestAttributeValueId}
                                setValue={setTestDataIntegrationDTO}
                                obj={testDataIntegrationDTO}
                                valueList={targetTestAttributeValueList}
                                hasNoneSelect={true}
                                valueKey='id'
                                labelKey='attribute'
                            />
                        </Grid>
                        {testDataIntegrationDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={testDataIntegrationDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === testDataIntegrationDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(testDataIntegrationDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === testDataIntegrationDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(testDataIntegrationDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};